<script>
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";
import SuppliersApi from "@/services/suppliers-api";

export default {
  data() {
    return {
      menuItems: menuItems,
      role:null,
      isInvoiceSupportedBySupplier: null,
    };
  },

  created(){
    this.role=sessionStorage.getItem("userr");
    this.getIsInvoiceSupported();
  },
  mounted() {

    var sideNavLinks = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < sideNavLinks.length; i++) {
      if (window.location.pathname === sideNavLinks[i].pathname) {
        matchingMenuItem = sideNavLinks[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */

      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add("active");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add("active");
                const parent6 = parent5.parentElement;
                if (parent6) {
                  parent6.classList.add("active");
                }
              }
            }
          }
        }
      }
    }
  },


  methods: {
    ...layoutMethods,
    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {

      event.preventDefault();
      const nextEl = event.target.nextSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    getIsInvoiceSupported() { 
      SuppliersApi.getIsInvoiceSupported() 
      .then(isInvoiceSupportedBySupplier => {
          this.isInvoiceSupportedBySupplier = isInvoiceSupportedBySupplier;
        })
    },

  },
};
</script>
<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-md topnav-menu active">
        <div class="collapse navbar-collapse active" id="topnav-menu-content" >
          <ul class="navbar-nav">
            <!-- Menu data -->

            <template v-for="(item, index) of menuItems">
              <li class="nav-item dropdown" :key="index" v-if="item.role==role" >
                <router-link
                  class="nav-link dropdown-toggle arrow-none side-nav-link-ref font-weight-bold"
                  v-if="!hasItems(item)"
                  id="topnav-components"
                  :to="item.link"
                  role="button"
                  @click="onMenuClick($event)"
                >
                 <i :class="`${item.icon} mr-2 font-size-20`"></i> {{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </router-link>

                <a
                  v-if="hasItems(item)"
                  class="nav-link dropdown-toggle arrow-none font-weight-bold"
                  @click="onMenuClick($event)"
                  id="topnav-components"
                  role="button"
                >
            
                  <i :class="`${item.icon} mr-1 font-size-20`"></i>
                   {{ $t(item.label) }}
                  <div class="arrow-down" v-if="hasItems(item)"></div>
                </a>

                <div
                  class="dropdown-menu row"
                  aria-labelledby="topnav-dashboard"
                  v-if="hasItems(item)"
                >
                  <template v-for="(subitem, index) of item.subItems"> 
                    <router-link 
                      class="col dropdown-item side-nav-link-ref"
                      :key="index"
                      v-if="!hasItems(subitem)  && ( !subitem.isInvoiceSupported  ||  ( subitem.isInvoiceSupported && isInvoiceSupportedBySupplier )  ) "
                      :to="subitem.link"
                      @click="onMenuClick($event)"
                      role="button"
                      >{{ $t(subitem.label) }}</router-link
                    >
                  </template>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<style >
    @media all and (max-width: 1024px) {
    #topnav-menu-content {
        padding-left: 20px;
    } 

    }
</style>


